import React from 'react';
import { Tooltip } from '@material-ui/core';

export const KEYWORD_MAP = {
  SAN: {
    label: 'SAN',
    title: 'Sanctions List (SAN)',
    description: 'Checks against comprehensive international and national sanctions lists, including UN, EU, US OFAC, and other critical global databases, to identify individuals and entities subject to sanctions.',
    bg: '#FCEBEB',
    color: '#A32D2D',
    border: '#F09595',
  },
  PEP: {
    label: 'PEP',
    title: 'Politically Exposed Persons (PEPs)',
    description: 'Focuses on high-risk individuals who have held or currently hold significant public office globally, adhering to FATF standards and other international regulations.',
    bg: '#E6F1FB',
    color: '#185FA5',
    border: '#85B7EB',
  },
  RCA: {
    label: 'RCA',
    title: 'Relatives or Close Associates (RCA)',
    description: 'Includes individuals closely associated with PEPs, who may pose similar financial and reputational risks due to their proximity to power.',
    bg: '#FAEEDA',
    color: '#854F0B',
    border: '#EF9F27',
  },
  OOL: {
    label: 'OOL',
    title: 'Other Official Lists (OOL)',
    description: 'Encompasses lists issued by supervisory authorities, regulators, and law enforcement — including advisories, enforcement orders, visa/travel bans, exclusion lists, trade restrictions, war crime lists, and warnings.',
    bg: '#E1F5EE',
    color: '#0F6E56',
    border: '#5DCAA5',
  },
  SI: {
    label: 'SI',
    title: 'Special Interest Persons (SI)',
    description: 'Targets individuals and entities implicated in significant criminal activities such as corruption, financial crime, trafficking, organized crime, terror, and tax crime.',
    bg: '#EEEDFE',
    color: '#534AB7',
    border: '#AFA9EC',
  },
  'SI-LT': {
    label: 'SI-LT',
    title: 'Special Interest Entity Lower Threshold (SI-LT)',
    description: 'Focuses on individuals and entities involved in lesser yet significant criminal offenses, monitoring potential risks in specific regions.',
    bg: '#FBEAF0',
    color: '#993556',
    border: '#ED93B1',
  },
  SCO: {
    label: 'SCO',
    title: 'Sanctioned Control Ownership (SCO)',
    description:
      'Identifies entities that are owned or controlled, directly or indirectly, by sanctioned individuals or organisations. This includes cases where control is exercised through shareholding, voting rights, or other means, even if the entity itself is not explicitly listed on sanctions registers.',
    bg: '#FFF4E5',
    color: '#9A5B00',
    border: '#F2B366',
  },
};

function KeywordPill({ keyword }) {
  const info = KEYWORD_MAP[keyword] || {
    label: keyword,
    title: keyword,
    description: keyword,
    bg: '#F1EFE8',
    color: '#5F5E5A',
    border: '#B4B2A9',
  };

  return (
    <Tooltip
      title={
        <React.Fragment>
          <strong style={{ fontSize: 14 }}>{info.title}</strong>
          <br />
          <span style={{ fontSize: 13 }}>{info.description}</span>
        </React.Fragment>
      }
      arrow
      placement="top">
      <span
        style={{
          display: 'inline-block',
          padding: '4px 12px',
          borderRadius: 12,
          fontSize: 14,
          fontWeight: 500,
          background: info.bg,
          color: info.color,
          border: `0.5px solid ${info.border}`,
          marginRight: 4,
          marginBottom: 2,
          cursor: 'default',
        }}>
        {info.label}
      </span>
    </Tooltip>
  );
}

export function KeywordPills({ value }) {
  return (
    <span style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {value.map((kw, i) => (
        <KeywordPill key={i} keyword={kw} />
      ))}
    </span>
  );
}
